import { render } from "./OrderTableGrid.vue?vue&type=template&id=28756e50"
import script from "./OrderTableGrid.vue?vue&type=script&lang=js"
export * from "./OrderTableGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QSlideItem from 'quasar/src/components/slide-item/QSlideItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QSlideItem,QBtn,QIcon,QChip});
